/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const ClarityOpsKey = 'clarity-ops-x9k2m' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
